var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserNavLinkIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 106.000000 104.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,104.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389 1011 c-88 -28 -154 -69 -218 -135 -96 -101 -141 -212 -141 -351 0 -200 111 -374 296 -462 72 -34 86 -37 188 -41 95 -4 120 -1 176 18 87 29 144 64 205 126 100 99 148 219 148 364 -1 216 -135 403 -341 476 -85 30 -227 32 -313 5z m323 -88 c88 -41 129 -75 180 -147 78 -111 100 -261 57 -389 -11 -34 -24 -66 -28 -70 -5 -5 -22 16 -39 46 -33 59 -99 122 -159 152 -21 11 -40 21 -42 23 -3 1 5 12 16 25 42 46 55 86 51 158 -5 84 -40 141 -109 177 -200 103 -409 -132 -280 -314 18 -26 31 -47 29 -49 -2 -1 -22 -12 -45 -24 -54 -27 -135 -109 -158 -161 -10 -22 -22 -40 -26 -40 -17 0 -52 119 -57 191 -10 171 84 336 236 413 74 37 115 45 217 43 77 -2 100 -7 157 -34z m-103 -91 c69 -37 92 -137 48 -203 -64 -96 -203 -86 -252 17 -59 125 80 252 204 186z m62 -371 c67 -32 120 -81 153 -140 l28 -52 -43 -39 c-88 -80 -223 -121 -335 -101 -76 14 -170 60 -213 105 -33 34 -33 36 -20 68 29 70 118 147 202 174 60 20 171 12 228 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNavLinkIcon2);
export default __webpack_public_path__ + "static/media/userNavLinkIcon2.82af82427f3b6e1f78312f2a2e08d285.svg";
export { ForwardRef as ReactComponent };